'use client';
import { Box, Text } from '@stone-payments/jade';
import { type ReactNode } from 'react';
import { RecurrencePlanSummary } from '../../app/components/recurrence/recurrencePlanSummary';
import { usePageSharedData } from '../../hooks/usePageSharedData';
import { DetailCheckout } from '../detailCheckout';
import { SummaryDetail } from '../saleSummary/sumaryDetail';

type SuccessProps = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  paymentLine?: string;
  children: ReactNode;
  image?: ReactNode;
};

export function Success({
  icon,
  title,
  subtitle,
  paymentLine,
  image,
  children,
}: SuccessProps) {
  const { detailItems, items, total, isRecurrence } = usePageSharedData();
  return (
    <div className="bg-jade-background-body h-screen overflow-y-auto">
      <div className="pt-jade-600 w-full flex flex-col items-center justify-center gap-jade-250">
        <Box className="max-w-[420px] min-h-[fit-content]">
          <div className="flex flex-col items-center p-jade-250">
            {icon}
            <div className="flex flex-col items-center gap-jade-150 mt-jade-250">
              <Text
                color="current-color"
                variant="heading-medium"
                className="text-center"
              >
                {title}
              </Text>
              <div className="mb-jade-150">
                <Text
                  color="medium"
                  variant="text-large"
                  weight="medium"
                  className="text-center"
                >
                  {subtitle}
                </Text>
              </div>
            </div>
            {image && (
              <div className="mb-jade-400 mt-jade-400 flex flex-col items-center gap-jade-50">
                {image}
                <Text
                  color="high"
                  variant="text-small"
                  weight="semibold"
                  className="text-center break-all"
                >
                  {paymentLine}
                </Text>
              </div>
            )}
            {children}
          </div>
        </Box>
        <div className="flex flex-col max-w-[420px] max-h-[550px] w-full gap-jade-250 mb-jade-300">
          {isRecurrence ? (
            <RecurrencePlanSummary />
          ) : (
            <>
              <DetailCheckout items={detailItems} />
              <SummaryDetail items={items} total={total} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
